import storage from "redux-persist/lib/storage";

import { REDUCER_PATHS } from "./config";

export const persistConfig = {
  key: "root",
  storage,
  whitelist: [REDUCER_PATHS.TOKEN],
};
